import {
    LOGIN, LOGOUT,
    FORGOT_PASSWORD, FORGOT_PASSWORD_VALIDATE_TOKEN, FORGOT_PASSWORD_CHANGE,
    USER_ACTIVATION, SEND_WELCOME_EMAIL,
    CHANGE_PASSWORD,
    CREATE_USER, UPDATE_USER, CHANGE_USER_PASSWORD, UPDATE_USER_STATUS, DELETE_USER,
    CREATE_CLIENT, UPDATE_CLIENT, UPDATE_CLIENT_STATUS, DELETE_CLIENT,
    FETCH_INVOICES, DOWNLOAD_INVOICE,
    FETCH_DELIVERY_NOTES, DOWNLOAD_DELIVERY_NOTE, DOWNLOAD_PACKING_LIST,
    DOWNLOAD_STOCK,
    FETCH_TECHNICAL_SHEETS, DOWNLOAD_TECHNICAL_SHEET
} from "../../../audit/audit-lib";

export default {
    "title": "Extranet Administration Panel / Audit",
    "description": "Registered events list",
    "filters": {
        "event": "Event",
        "user": "User",
        "client": "Client"
    },
    "auditTableHeader": "Total events: <0>{{count}}</0>",
    "auditTableColumns": {
        "event": "Event",
        "user": "User",
        "client": "Client",
        "date": "Event date",
        "details": "Event details"
    },
    "nameCollection": "events",
    "eventOptions": {
        LOGIN: "Login",
        LOGOUT: "Logout",
        FORGOT_PASSWORD: "Forgot password",
        FORGOT_PASSWORD_VALIDATE_TOKEN: "Validate token of forgot password",
        FORGOT_PASSWORD_CHANGE: "Forgot password change",
        USER_ACTIVATION: "User activation",
        SEND_WELCOME_EMAIL: "Send welcome email",
        CHANGE_PASSWORD: "Change password",
        CREATE_USER: "Create user",
        UPDATE_USER: "Update user",
        CHANGE_USER_PASSWORD: "Change password to user",
        UPDATE_USER_STATUS: "Update status to user",
        DELETE_USER: "Delete user",
        CREATE_CLIENT: "Create client",
        UPDATE_CLIENT: "Update client",
        UPDATE_CLIENT_STATUS: "Update status to client",
        DELETE_CLIENT: "Delete client",
        FETCH_INVOICES: "Fetch invoices",
        DOWNLOAD_INVOICE: "Download invoice",
        FETCH_DELIVERY_NOTES: "Fetch delivery notes",
        DOWNLOAD_DELIVERY_NOTE: "Download delivery note",
        DOWNLOAD_PACKING_LIST: "Download packing list",
        DOWNLOAD_STOCK: "Download stocks",
        stocks_service: "Stocks service",
        FETCH_TECHNICAL_SHEETS: "Fetch technical sheets",
        DOWNLOAD_TECHNICAL_SHEET: "Download technical sheet"
    }
}